export const MODULE_NAME = 'owner'

export const NUXT_PAGE_OWNER_CUSTOMER_LEGAL = `${MODULE_NAME}-customer-legal`

export const NUXT_PAGE_OWNER_CUSTOMER_LEGAL_EDIT = `${MODULE_NAME}-customer-legal-edit`

export const NUXT_PAGE_OWNER_CUSTOMER_DAC7 = `${MODULE_NAME}-customer-dac7`

export const START_YEAR_DAC7 = 2023
